<template>
  <div>
    <!-- My account area start -->
    <div class="main-content shop-page-account">
      <div class="container">
        <div class="container block-page-login" style="margin: 32px 0;">
          <div id="primary">
            <h1 class="page-title">Account</h1>
            <div class="row">
              <div class="col-lg-auto col-xs-12 col-sm-4 col-md-3 col-lg-3">
                <div class="wrapper_tabcontent customer">
                  <router-link to="/my-account" class="btn btn--full account">
                    <i class="icon-check-circle"></i>Dashboard
                  </router-link>
                  <h3><i class="icon-menu"></i>Orders</h3>
                  <router-link class="btn btn--full view-address" to="/my-address">
                    <i class="icon-map-pin"></i>View Addresses
                  </router-link>
                  <!-- <router-link class="btn btn--full view-address" to="/wishlist">
                    <i class="icon-heart"></i>View Wishlist
                  </router-link> -->
                  <router-link to="/checkout" class="btn btn--full checkout">
                    <i class="icon-check-circle"></i>Check Out
                  </router-link>
                  <button @click="logout" class="btn btn-link">
                    <i class="icon-log-out"></i>Logout
                  </button>
                </div>
              </div>
              <div class="account-content col">
                <div class="order-history">
                  <h3>Order History</h3>
                  <p class="none" v-if="orders.length === 0">
                    <router-link to="/shop">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M3.01 11.2202V15.7102C3.01 20.2002 4.81 22.0002 9.3 22.0002H14.69C19.18 22.0002 20.98 20.2002 20.98 15.7102V11.2202"
                          stroke="#96AE00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M12 12C13.83 12 15.18 10.51 15 8.68L14.34 2H9.67L9 8.68C8.82 10.51 10.17 12 12 12Z"
                          stroke="#96AE00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path
                          d="M18.31 12C20.33 12 21.81 10.36 21.61 8.35L21.33 5.6C20.97 3 19.97 2 17.35 2H14.3L15 9.01C15.17 10.66 16.66 12 18.31 12Z"
                          stroke="#96AE00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path
                          d="M5.64 12C7.29 12 8.78 10.66 8.94 9.01L9.16 6.8L9.64 2H6.59C3.97 2 2.97 3 2.61 5.6L2.34 8.35C2.14 10.36 3.62 12 5.64 12Z"
                          stroke="#96AE00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M12 17C10.33 17 9.5 17.83 9.5 19.5V22H14.5V19.5C14.5 17.83 13.67 17 12 17Z"
                          stroke="#96AE00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      Make your first order
                    </router-link>
                    You haven't placed any orders yet.
                  </p>

                  <div class="table-content table-responsive" v-if="orders.length > 0">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Order #</th>
                          <th>Placed On</th>
                          <th>Total</th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="order in orders" :key="order.id">
                          <td>{{ order.reference }}</td>
                          <td>{{ formatDate(order.system_date) }}</td>
                          <td>{{ order.total_order_value }}</td>
                          <td>{{ order.order_approval_status }}</td>
                          <td>
                            <router-link :to="'/order/' + order.id" class="btn btn--full tp-btn-h1 checkout">
                              <i class="icon-view"></i>View
                            </router-link>
                            <!-- <router-link v-if="order.order_approval_status=='Pending'" :to="'/order/' + order.id" class="btn btn--full tp-btn-h1 checkout">
                              <i class="icon-view"></i>Cancel
                            </router-link> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>



              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- My account area end -->

    <!-- cta area start -->
    <cta-area></cta-area>
    <!-- cta area end -->
  </div>
</template>


<script>
import CtaArea from '@/components/cta/cta-area.vue'

export default {
  name: 'MyAccountPage',
  components: {
    CtaArea,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')) || { name: 'Guest', email: '' },
      orders: [], // Array to hold fetched orders
    }
  },
  computed: {
    isLoggedIn() {
      return !!this.user
    },
  },
  methods: {
    async logout() {
      try {
        const response = await this.$axios.post('/logout', {}, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
          },
        })

        if (response.status === 200) {
          localStorage.removeItem('user')
          localStorage.removeItem('auth_token')
          window.location.href = '/login'
        } else {
          console.error('Logout failed:', response.data.message || 'Unknown error')
        }
      } catch (error) {
        console.error('Error during logout:', error.response?.data?.message || error.message)
      }
    },
    async fetchOrdersByUserId(userId) {
      try {
        const response = await this.$axios.get(`/orders/user/${userId}`)
        this.orders = response.data
      } catch (error) {
        console.error('Error fetching orders:', error.response?.data || error)
      }
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' }
      return new Date(dateString).toLocaleDateString(undefined, options)
    }
  },
  mounted() {
    if (this.isLoggedIn) {
      this.fetchOrdersByUserId(this.user.id)
    }
  },
}
</script>



<style scoped>
/* Add any scoped CSS styles if required */
.shop-page-account h1.page-title {
  color: #222222;
  font-size: 38px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  margin: 0 0 30px;
  line-height: 1;
  border-bottom: 2px solid #ebebeb;
  padding-bottom: 15px
}

.wrapper_tabcontent.customer h3 {
  height: 45px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  text-transform: uppercase;
  color: #fff;
  background-color: #222222;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  width: 100%;
  border-radius: 3px;
  border: 1px solid #222222;
  padding: 0 15px
}

.wrapper_tabcontent.customer .btn {
  height: 45px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  text-transform: uppercase;
  color: #222222;
  background-color: #f6f6f6;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ebebeb;
  padding: 0 15px
}

.wrapper_tabcontent.customer .btn:hover {
  border-color: var(--color-btn-hover);
  background-color: var(--color-btn-hover);
  color: var(--color-btn-text_hover)
}

.wrapper_tabcontent.customer h3 i,
.wrapper_tabcontent.customer .btn i {
  font-size: 17px;
  margin-right: 10px
}

.account-content p.title-customer {
  line-height: 45px;
  font-size: 14px;
  text-transform: capitalize
}

.account-content p.title-customer span {
  font-weight: 700;
  text-transform: capitalize;
  color: #222222
}

.account-content p.title-customer a {
  color: var(--color-hover);
  text-decoration: underline
}

.order-history {
  margin-bottom: 65px
}

.account_details h3,
.order-history h3 {
  color: #222222;
  margin: 0 0 10px;
  display: flex;
  position: relative;
  text-align: center;
  letter-spacing: -.03em;
  font-weight: 600;
  font-size: 18px;
  line-height: 45px
}

.order-history p.none {
  display: flex;
  align-items: center;
  height: 45px;
  margin-bottom: 10px
}

.order-history p.none a {
  display: flex;
  align-items: center;
  text-decoration: underline;
  margin-right: 10px
}

.order-history p.none a svg {
  margin-right: 10px
}

.table .h3 {
  color: #222222
}

.account_details .table-res .table {
  border: 1px solid #e5e5e5;
  border-bottom: none;
  border-right: none
}

.account_details .table-res .table td {
  border-right: 1px solid #e5e5e5
}

@media (max-width: 400px) {
  .order-history p.none {
    flex-direction: column
  }
}

h3,
.h3,
h4,
.h4 {
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0px;
}

td {
  padding: 10px;
  border-style: none;
  color: #4f4f4f !important;
  border-width: 0 1px 1px 0;
}
.tp-btn-h1{
  background: #f03723;
}
</style>
